import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table view for balance adjustments.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Get current user parameter

        return {
            view: 'datatable', // DataTable view
            id: 'datatable', // ID for the DataTable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: true, // Enable vertical scrolling
            columns: [
                // Define columns for the DataTable
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // Column for ID
                {
                    id: 'UserId',
                    header: _('ID Usuario'), // Localized header for User ID
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'UserName',
                    header: _('Nombre Usuario'), // Localized header for User Name
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'CreatedLocalDate',
                    header: _('Fecha de Creación'), // Localized header for Creation Date
                    fillspace: 0,
                    minWidth: 0,
                    width: 150,
                    sort: 'text',
                    format: dateFormat, // Date format for display
                },
                {
                    id: 'Amount',
                    header: _('Monto'), // Localized header for Amount
                    width: 100,
                    sort: 'int',
                    format: webix.i18n.priceFormat, // Price format for display
                    exportType: 'number', // Export type for the column
                },
                {
                    id: 'Type',
                    header: _('Tipo de ajuste'), // Localized header for Adjustment Type
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'), // Localized header for Description
                    width: 250,
                    sort: 'int',
                },
                {
                    id: 'TypeBalance',
                    header: _('Tipo saldo'), // Localized header for Balance Type
                    options: [
                        // Options for the dropdown
                        { id: '0', value: _('Saldo recargas') }, // Recharge Balance
                        { id: '1', value: _('Saldo retiros') }, // Withdrawal Balance
                    ],
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'UserCreated',
                    header: _('Usuario Creo'), // Localized header for User Created
                    width: 250,
                    sort: 'int',
                },
            ],
            on: {
                // Event handlers for the DataTable
                onBeforeLoad: function () {
                    // Before loading data
                    this.showOverlay(
                        // Show loading overlay
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    );
                },
                onAfterLoad: function () {
                    // After loading data
                    this.hideOverlay(); // Hide loading overlay
                },
            },
            ready: function () {
                // When the DataTable is ready
                if (!this.count()) {
                    // Check if there are no records
                    webix.extend(this, webix.OverlayBox); // Extend with OverlayBox
                    this.showOverlay(
                        // Show no data overlay
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                            _('No hay datos') + // Localized message for no data
                            '</div>',
                    );
                }
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID for pagination
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var filter = ''; // Filter string for data loading
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'es/BalanceAdjustments/GetBalanceAdjustments?PlayerId=' + cur_user + '&'; // Base URL for API requests
        var options = []; // Options for adjustment types
        var popupAdd; // Popup for adding adjustments

        // Event listener for filtering balance adjustments
        this.on(this.app, 'balanceAdjustments:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user to filter
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for item click in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });

        // AJAX request to get adjustment types
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for request
            })
            .post(devConfig.geturlApi() + 'Select/GetTypesAdjustments', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Handle error response
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    options = resp.Data; // Store adjustment types
                    popupAdd = webix.ui({
                        // Create popup for adding adjustments
                        view: 'window',
                        id: 'AddAdjustments',
                        width: 450,
                        height: 450,
                        fullscreen: screen.width > 500 ? false : true, // Responsive design
                        head: {
                            view: 'toolbar',
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Ajustar Saldo'), // Localized label for popup
                                    align: 'center',
                                },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide popup on close
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the popup
                        modal: true, // Modal popup
                        body: {
                            view: 'form', // Form inside the popup
                            id: 'addform', // ID for the form
                            elements: [
                                // Form elements
                                {
                                    view: 'combo',
                                    label: _('Tipo Saldo:'), // Localized label for Balance Type
                                    name: 'TypeBalance',
                                    required: true, // Required field
                                    options: [
                                        // Options for Balance Type
                                        { id: '0', value: _('Saldo recargas') }, // Recharge Balance
                                        { id: '1', value: _('Saldo retiros') }, // Withdrawal Balance
                                    ],
                                    labelWidth: 150, // Label width
                                },
                                {
                                    view: 'combo',
                                    label: _('Tipo de ajuste') + ':', // Localized label for Adjustment Type
                                    name: 'Type',
                                    required: true, // Required field
                                    options: options, // Options from AJAX response
                                    labelWidth: 150, // Label width
                                },
                                {
                                    view: 'textarea',
                                    label: _('Descripción:'), // Localized label for Description
                                    name: 'Description',
                                    labelWidth: 150, // Label width
                                    required: true, // Required field
                                },
                                {
                                    view: 'text',
                                    label: _('Monto:'), // Localized label for Amount
                                    name: 'Amount',
                                    type: 'number', // Input type
                                    labelWidth: 150, // Label width
                                    required: true, // Required field
                                },
                                {
                                    view: 'text',
                                    label: _('Confirmar Monto:'), // Localized label for Confirm Amount
                                    name: 'ConfirmAmount',
                                    type: 'number', // Input type
                                    labelWidth: 150, // Label width
                                    required: true, // Required field
                                },
                                {
                                    cols: [
                                        // Button layout
                                        {
                                            view: 'button',
                                            value: _('Cancelar'), // Localized label for Cancel button
                                            click: function () {
                                                this.getTopParentView().hide(); // Hide popup on cancel
                                                $$('addform').setValues(
                                                    // Reset form values
                                                    $$('addform').getCleanValues(),
                                                );
                                            },
                                        },
                                        {
                                            view: 'button',
                                            type: 'form',
                                            value: _('Guardar'), // Localized label for Save button
                                            click: function ($e) {
                                                var values = $$('addform').getValues(); // Get form values
                                                if ($$('addform').validate()) {
                                                    // Validate form
                                                    if (
                                                        values.Amount == values.ConfirmAmount // Check if amounts match
                                                    ) {
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json', // Set content type for request
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() + 'BalanceAdjustments/Adjustment',
                                                                '{"UserId":"' +
                                                                    cur_user +
                                                                    '", "TypeBalance":"' +
                                                                    values.TypeBalance +
                                                                    '", "Amount":"' +
                                                                    values.Amount +
                                                                    '", "Type":"' +
                                                                    values.Type +
                                                                    '", "Description":"' +
                                                                    values.Description +
                                                                    '"}', // Send adjustment data
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message('Error! '); // Handle error response
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var json = JSON.parse(
                                                                            text, // Parse response
                                                                        );
                                                                        if (
                                                                            json.HasError // Check for errors in response
                                                                        ) {
                                                                            if (json.CodeError != 110012) {
                                                                                webix.message({
                                                                                    title: _('¡Error!'),
                                                                                    type: 'alert-error',
                                                                                    text: json.AlertMessage, // Show error message
                                                                                });
                                                                            }
                                                                        } else {
                                                                            webix.message(
                                                                                'Saldo Ajustado', // Show success message
                                                                            );
                                                                            grid.clearAll(); // Clear grid data
                                                                            grid.load(
                                                                                url +
                                                                                    '?start=0&count=' +
                                                                                    grid.data.$pagesize +
                                                                                    filter, // Reload grid data
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                        $$('addform').setValues(
                                                            // Reset form values
                                                            $$('addform').getCleanValues(),
                                                        );
                                                        this.getTopParentView().hide(); // Hide popup after saving
                                                    } else {
                                                        webix.message({
                                                            title: _('¡Error!'), // Localized error title
                                                            type: 'alert-error',
                                                            text: _(
                                                                'Monto y confirmar monto no coinciden', // Localized error message
                                                            ),
                                                        });
                                                    }
                                                } else {
                                                    webix.message({
                                                        title: _('¡Error!'), // Localized error title
                                                        type: 'alert-error',
                                                        text: _(
                                                            'Completa los campos...', // Localized error message
                                                        ),
                                                    });
                                                }
                                            },
                                        },
                                    ],
                                },
                            ],
                            elementsConfig: {
                                // Configuration for form elements
                                on: {
                                    onChange: function () {
                                        this.validate(); // Validate on change
                                    },
                                },
                            },
                        },
                    });
                },
            });
        this.on(this.app, 'addAdjustment:button', (item) => {
            // Event listener for adding adjustments
            if (options.length > 0) {
                // Check if options are available
                popupAdd.show(); // Show popup
                $$('addform').clearValidation(); // Clear validation messages
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Localized error message
                    title: _('¡Error!'), // Localized error title
                    type: 'alert-error',
                });
            }
        });
    }
}

// FILE DOCUMENTED
